module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Warning-1-circle-39004600c989ee72bdba728ee8a2b99c.svg";